import React from 'react';
import styled from 'styled-components';
import { BodyText, Spacer, Title } from '@kvdbil/components';
import { useTranslation } from '~/Locale';
import AuctionFavouriteButton from '~/App/shared/components/AuctionFavouriteButton';
import TooltipPrice from '~/App/shared/components/TooltipPrice';
import { ProcessedAuction } from '~/App/shared/interfaces/ProcessedAuction';
import { getCarDealerPrice, ProcessedAuctionStates } from '~/helpers/auction';
import AuctionInfo from './AuctionInfo';
import { BuyMethodContainer } from './BuyMethodBox';
import { isHeavyEquipmentObject } from '../helpers';

const TooltipPriceContainer = styled.div`
  margin-top: -0.5rem;
`;

interface Props {
  auction: ProcessedAuction;
  auctionStates: ProcessedAuctionStates;
  isRecreationalVehicle: boolean;
}

const ComingSoonCostInformation = ({
  auction,
  auctionStates,
  isRecreationalVehicle
}: Props) => {
  const carDealerPrice = getCarDealerPrice(auction);
  const { t } = useTranslation();

  const isHeavyEquipment = isHeavyEquipmentObject(auction.processObject);

  return (
    <>
      <BuyMethodContainer>
        <Title as="h3">{t('Car coming soon')}</Title>
        <Spacer />
        <AuctionInfo
          auction={auction}
          auctionStates={auctionStates}
          isRecreationalVehicle={isRecreationalVehicle}
          isComingSoon
          isHeavyEquipment={isHeavyEquipment}
        />
        {carDealerPrice && (
          <TooltipPriceContainer>
            <TooltipPrice
              title={t('Car dealer price')}
              price={carDealerPrice}
              explanation={t('Car dealer price explanation')}
            />

            <Spacer />
          </TooltipPriceContainer>
        )}
        <BodyText>
          {t("Save the vehicle, to get notified when it's available")}
        </BodyText>
        <Spacer height={2} />

        <AuctionFavouriteButton
          auctionId={auction.id}
          color="info"
          fullWidth
          size="regular"
        />
      </BuyMethodContainer>
    </>
  );
};

export default ComingSoonCostInformation;
